"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Center;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, core_1.makeStyles)(() => ({
    centered: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: (props) => props.direction,
    },
}));
/**
 * Center content with flex container layout
 */
function Center({ children, className, direction = 'row', ...rest }) {
    const classes = useStyles({
        direction,
    });
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.centered, className), ...rest }, children));
}
